import { TimeoutRequestConfigurationEnum } from "@/main/services/enum/TimeoutRequestConfigurationEnum";
import axios from "axios";
import { installDevcertInFlightProbe } from "./devcertInFlightProbe";
import { AUTHORIZATION_NAME } from "@/main/services/storage";
import { getAPIAuthorization } from "@/main/services/utils";

const versionIntegration = import.meta.env.VITE_API_VERSION;

const apiIntegration = axios.create({
	baseURL: `${import.meta.env.VITE_API_BASE_URL}api/integration/${versionIntegration}/`,
	timeout: TimeoutRequestConfigurationEnum.Default,
	headers: {
		"Access-Control-Allow-Origin": "*",
	},
});

installDevcertInFlightProbe(apiIntegration);

apiIntegration.interceptors.request.use((config) => {
	config.headers[AUTHORIZATION_NAME] = getAPIAuthorization();
	return config;
});
// handleInterceptorsIntegration();

const baseUrlIntegration = apiIntegration.defaults.baseURL;

export { apiIntegration, baseUrlIntegration, versionIntegration };
